module.exports = __webpack_public_path__ + "img/bar-chart-06.cd558a1d.svg";